<div class="designs-modal-container">
    <header>
        <span>Gift Card Designs</span>
        <mat-icon (click)="close()">close</mat-icon>
    </header>
    <mat-divider></mat-divider>
    <div class="design-category-grid-list">
        <div
            class="design-category-grid-container"
            *ngFor="let category of categories"
        >
            <div class="sub-title">{{ category.name }}</div>
            <div class="design-grid">
                <div
                    skeletonData
                    [showSkeleton]="!image.complete"
                    [placeholderWidth]="'100%'"
                    [placeholderHeight]="'100%'"
                    class="tile"
                    *ngFor="let design of category.designs"
                    (click)="select(design)"
                >
                    <!-- load/error required for Angular to trigger change detection -->
                    <img
                        #image
                        [src]="design.image"
                        [ngClass]="{
                            'selected-image': selectedId === design.id
                        }"
                        qa="gift-card-design"
                        (load)="(image.complete)"
                        (error)="(image.complete)"
                    />
                    <div class="selected" *ngIf="selectedId === design.id">
                        <mat-icon
                            class="mat-icon-check"
                            *ngIf="selectedId === design.id"
                            aria-hidden="false"
                            aria-label="Selected design"
                        >
                            done
                        </mat-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <mat-divider></mat-divider>
    <footer>
        <button
            mat-stroked-button
            (click)="close()"
            qa="designs-modal-cancel-button"
            class="cancel-button"
        >
            Cancel
        </button>
        <button
            mat-flat-button
            color="primary"
            (click)="confirm()"
            qa="designs-modal-select-button"
            class="confirm-button"
            #confirmButton
        >
            Select
        </button>
    </footer>
</div>
